module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom goldBg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("Our Story Begins with a Pressing Need")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('router-link', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "to": "/our-story"
    }
  }, [_vm._v("More Stories")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Our Mission:")]), _vm._v(" Pencils For Kids UK is dedicated to helping children in need in developing countries to attend school and, in doing so, build the foundation for a better future. We partner with other like-minded individuals, organizations and corporate sponsors to fulfill this mission. We believe that, working together, we can transform the world, one child at a time.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7e3ae0f1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/OurStory.vue
// module id = 405
// module chunks = 2